import { goldMantineTuple, oceanMantineTuple, oceanRamp } from "./primitives";
import { generateStandardPalette } from "./palette";

/** Legacy collect-ui `color="brand"` registration — ocean teal tuple. */
export const legacyBrandOcean = oceanMantineTuple;

/** Legacy role name on collect-ui / canvas-ui before defaultBrand rollout — gold tuple. */
export const legacyBrandGold = goldMantineTuple;

/** @deprecated Use legacyBrandOcean — kept as `primary` export for createBaseTheme `brand` slot. */
export const primary = legacyBrandOcean;

/** @deprecated Use legacyBrandGold — kept as `secondary` export for createBaseTheme gold CTA slot. */
export const secondary = legacyBrandGold;

/** Accent aligned to ocean600 (replaces #1A7A9E). */
export const accent = generateStandardPalette(oceanRamp[600]);

export const ocean = oceanMantineTuple;
export const gold = goldMantineTuple;

export { GOLD_BASE_HEX } from "./primitives";
